import { Currency } from '@fiverr-private/currencies_plugin/dist/interface';

export interface RecommendationItem {
    sellerId: number;
    gigId: number;
    note?: string | null;
}

export interface MatchmakingList {
    id: string;
    name: string;
    operatorId: string;
    operatorName: string;
    items: RecommendationItem[];
    createdAt: string;
    updatedAt: string;
}

export interface EnrichedRecommendationItem extends RecommendationItem, Record<string, unknown> {}

export interface EnrichedMatchmakingList extends MatchmakingList {
    items: EnrichedRecommendationItem[];
}

export interface UserData {
    username: string;
    gigs_count: number | null;
    orders_count: number | null;
    in_show_online_toggle_list: boolean;
}

export interface InitialProps extends Record<string, unknown> {
    matchmakingList: EnrichedMatchmakingList;
    userData?: UserData | null;
    displayMode: DisplayMode;
    currency: Currency;
    matchmakingNotes?: Record<string, string>;
}

export enum DisplayMode {
    Gigs = 'gigs',
    Sellers = 'sellers',
}

export interface SaveToListItem {
    resource_id: number;
    resource_type: 'GIG' | 'SELLER';
}
